import { styled } from 'baseui'
import type { Theme } from 'baseui'

export const PulseFieldContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
  minWidth: 0,
})

export const PulseFieldLabel = styled('div', ({ $theme }: { $theme: Theme }) => ({
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '18px',
  color: $theme.colors.textPulseLabel,
}))

export const PulseFieldRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  minWidth: 0,
})
